import React from 'react';

import { Grid, FormControl, Typography } from '@material-ui/core';
import FilterChip from 'src/App/Components/Chips/FilterChip';
import { FilterVal } from 'src/interfaces/iproptypes';

const roomTypesObj = {
  entire_home: 'Entire House',
  condo: 'Apartment',
  private_room: 'Private Room',
  shared_room: 'Shared Room',
  hotel_room: 'Hotel Room',
};

const BedroomFilter = ({ filterVal, setFilterVal }) => {
  const handleBedroomsChange = (value: string | number) => {
    if (
      isNaN(Number(value)) &&
      !['private_room', 'hotel_room', 'shared_room'].includes((value as unknown) as string)
    ) {
      return null;
    }

    let newValue = filterVal.bedrooms;

    if (value !== 100 && newValue.includes(100)) {
      newValue.splice(newValue.indexOf(100), 1);
    }

    if (newValue.includes(value)) {
      newValue = newValue.filter(val => val !== value);
    } else {
      newValue.push(value);
    }

    if (value === 100) {
      newValue = [100];
    }

    const _room_type = filterVal.roomType;

    localStorage.setItem('bedroom_number', newValue.toString());
    setFilterVal((filterVal: FilterVal) => {
      return { ...filterVal, bedrooms: newValue as number[] };
    });

    return null;
  };

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 500, color: '#000' }}>
        Bedrooms
      </Typography>

      <Grid
        xs={12}
        item
        container
        justifyContent="flex-start"
        style={{ width: '100%', gap: '5px' }}
      >
        <FilterChip
          value={100}
          label={'Any'}
          handleOnClick={() => handleBedroomsChange(100)}
          variant={filterVal.bedrooms.includes(100) ? 'filled' : 'outlined'}
        />
        {[0, 1, 2, 3, 4, 5, 6, 'private_room', 'shared_room', 'hotel_room'].map(
          (bedRoomType, index) => (
            <FilterChip
              value={bedRoomType}
              label={
                typeof bedRoomType === typeof ''
                  ? bedRoomType[0].toUpperCase()
                  : bedRoomType === 0
                  ? 'Studio'
                  : bedRoomType === 6
                  ? '6+'
                  : bedRoomType
              }
              handleOnClick={() => handleBedroomsChange(bedRoomType)}
              variant={
                !filterVal.bedrooms.includes(bedRoomType) || filterVal.bedrooms.includes(100)
                  ? 'outlined'
                  : 'filled'
              }
              tooltipText={roomTypesObj[bedRoomType] ? roomTypesObj[bedRoomType] : undefined}
            />
          )
        )}
      </Grid>
    </FormControl>
  );
};

export default BedroomFilter;
